<template>
    <!--    https://www.svgrepo.com/svg/476947/timezone-->
    <svg
        width="800px"
        height="800px"
        viewBox="0 0 1024 1024"
        class="icon"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M618.666667 192L362.666667 106.666667 106.666667 192v682.666667l256-85.333334 256 85.333334 256-85.333334V106.666667z"
            fill="#FFECB3"
        />
        <path d="M362.666667 106.666667v682.666666l256 85.333334V192z" fill="#FFD54F" />
        <path
            d="M917.333333 661.333333c0 141.376-114.624 256-256 256s-256-114.624-256-256 114.624-256 256-256 256 114.624 256 256"
            fill="#00ACC1"
        />
        <path
            d="M853.333333 661.333333c0 106.048-85.952 192-192 192s-192-85.952-192-192 85.952-192 192-192 192 85.952 192 192"
            fill="#EEEEEE"
        />
        <path d="M640 512h42.666667v149.333333h-42.666667z" fill="" />
        <path d="M646.954667 675.712l28.757333-28.757333 81.045333 81.045333-28.757333 28.757333z" fill="" />
        <path d="M693.333333 661.333333a32 32 0 1 1-64.021333-0.021333A32 32 0 0 1 693.333333 661.333333" fill="" />
    </svg>
</template>
<script>
export default {
    name: "TimeZoneIcon",
};
</script>
